<template>
    <div class="account">
        <Header :code="code">{{ $t('messages.account.account') }}</Header>
        <v-container>
             <v-row dense>
                <v-col cols="12"><h3 class="pl-4">{{ $t('messages.account.profil') }}</h3></v-col>
            </v-row>
            
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('messages.account.nom') }}</v-list-item-title>
                    <v-list-item-subtitle>{{user.nom}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('messages.account.prenom') }}</v-list-item-title>
                    <v-list-item-subtitle>{{user.prenom}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('messages.account.langue') }}</v-list-item-title>
                    <v-list-item-subtitle>{{user.langue.libelle}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('messages.account.identifiant') }}</v-list-item-title>
                    <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('messages.account.password') }}</v-list-item-title>
                    <v-list-item-subtitle>*********</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
           
        </v-container>
        <Footer02/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer02 from '@/components/Footer02'

export default {
    name: 'Account',
    props: ['code'],
    components: {
        Header,
        Footer02
    },
    data() {
        return {
        }
    },
    methods: {
        
    },
    computed: {
        user: function(){
            return this.$store.state.user;
        }
    },
    watch: {
    },
    created() {
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
    },
}
</script>
<style lang="scss">
    .account {
        padding-top:8vh;
        font-size: 0.9em;
        h3 {
            font-size:1.4em;
        }
    }
</style>